// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","cityCardButtons":"city-card-buttons_cityCardButtons__iN1pG","investmentOpportunities":"city-card-buttons_investmentOpportunities__3SLVb"};